/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import TrashOutline from './trash-outline-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <TrashOutline {...validProps} />;
}
SvgComponent.iconName = 'trashOutline';

export const TrashOutlineIcon = svgIconWrapper(SvgComponent);
